import { 
  RouterProvider,
  createBrowserRouter
} from 'react-router-dom'
import Home from './pages/home'
import Chat from './pages/chat'
import MpChat from './pages/mpChat'

const router = createBrowserRouter([
  {
    path: '/:oid',
    element: <Home />,
  },
  {
    path: '/chat/:oid',
    element: <Chat />,
  },
  {
    path: '/mpchat/:contactId',
    element: <MpChat />,
  }
])

export default function Router() {
  return (
    <RouterProvider router={router} />
  )
}
